// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"4d4e28a4","295":"2ae05cb3","296":"2cc2cba0","574":"25eca856","698":"dae535b0","950":"21df9bc6"}[chunkId] + ".chunk.css";
};